import TaskList from '@/components/TaskModal/TaskList.tsx';
import TaskListCta from '@/components/TaskModal/TaskListCta.tsx';
import TaskModal from '@/components/TaskModal/TaskModal.tsx';
import TaskModalFooter from '@/components/TaskModal/TaskModalFooter.tsx';

import { ModalType } from '@/models/Modal.ts';
import { TaskModalMode } from '@/models/TaskModalMode.ts';
import { TaskPrefill } from '@/models/TaskPrefill.ts';
import { EnrichedTask } from '@/models/doc-cirrus/DCTask.ts';

import { openModal } from '@/services/modalService.tsx';

import { useTaskFormStore } from '@/stores/taskFormStore.ts';
import { useTaskViewStore } from '@/stores/taskViewStore.ts';

interface OpenTaskModalOptions {
    task?: EnrichedTask;
    mode: TaskModalMode;
}

export const openTaskModal = ({ task, mode }: OpenTaskModalOptions): void => {
    useTaskViewStore.setState({
        task_modal_mode: mode,
        selected_task_id: task?.id ?? '',
        selected_task_instance_id: task?.instance_id ?? '',
    });

    openModal({
        modalId: ModalType.TASK,
        title: (
            <>
                {task && <TaskListCta />}
                Aufgabe
            </>
        ),
        size: 'xl',
        children: <TaskModal />,
        onClose: () => {
            // Defer state updates to avoid render-during-render error
            setTimeout(() => {
                useTaskViewStore.setState({ selected_task_id: undefined });
                useTaskFormStore.getState().clearForm();
            }, 0);
        },
        footer: <TaskModalFooter />,
        classNames: {
            childrenWrapper: 'h-[60vh]',
            title: 'flex gap-2',
        },
        siblings: <TaskList />,
    });
};

interface OpenBookingTaskModalOptions {
    mode: TaskModalMode;
    task?: EnrichedTask;
    prefill?: TaskPrefill;
    onSaved?: (task: EnrichedTask) => void;
    onDeleted?: (task: EnrichedTask) => void;
}

export const openBookingTaskModal = ({
    mode,
    task,
    prefill,
    onSaved,
    onDeleted,
}: OpenBookingTaskModalOptions): void => {
    useTaskViewStore.setState({
        task_modal_mode: mode,
        selected_task_id: task?.id ?? '',
        selected_task_instance_id: task?.instance_id ?? prefill?.instance_id ?? '',
    });

    openModal({
        modalId: ModalType.TASK,
        title: <>Aufgabe</>,
        size: 'xl',
        children: <TaskModal prefill={prefill} onSaved={onSaved} onDeleted={onDeleted} />,
        onClose: () => {
            // Defer state updates to avoid render-during-render error
            setTimeout(() => {
                useTaskViewStore.setState({ selected_task_id: undefined });
                useTaskFormStore.getState().clearForm();
            }, 0);
        },
        footer: <TaskModalFooter />,
        classNames: {
            childrenWrapper: 'h-[60vh]',
        },
    });
};
